import { useCallback, useEffect, useRef, useState } from "react";
import { ScheduleSituation } from "../api/getMySchedules";
import { transformDateToType } from "../utils/date-util/dateUtils";

// TODO: Possibilidade de converter para um websocket seria ideal
/**
 * Hook que cria um interval de 1 minuto que verifica se a data atual é maior que (horaAtendimento - 20min);
 * @param situation
 * @param horaAtendimento
 * @returns {Object}
 * {
 * 		showTelemedicine: boolean; true caso horaAtual >= (horaAtendimento - 20min)
 * 		canCancel: boolean; true caso usuário poder cancelar o agendamento;
 * }
 */
const useTimer = (situation: ScheduleSituation, horaAtendimento: string | undefined): { showTelemedicine: boolean; canCancel: boolean } => {
	const [showTelemedicine, setShowTelemedicine] = useState(false);
	const [canCancel, setCanCancel] = useState(true);
	const shouldCalculate = useRef(true);

	const handleVerifyTime = useCallback(() => {
		if (horaAtendimento) {
			const date = transformDateToType(horaAtendimento);
			const currentDate = transformDateToType(new Date());

			if (currentDate >= date.minus({ minutes: 20 })) {
				setShowTelemedicine(true);
				shouldCalculate.current = false;
			}
			if (currentDate >= date) {
				setCanCancel(false);
			}
		}
	}, [horaAtendimento]);

	const handleValidate = useCallback(() => {
		if (!horaAtendimento) {
			return false;
		}

		const date = transformDateToType(horaAtendimento);
		const todayDate = transformDateToType(new Date());
		// Caso tiver passado o dia do agendamento, não pode cancelar
		if (todayDate < date && todayDate.day !== date.day) return true;

		if (date.month === todayDate.month) {
			if (todayDate.day > date.day) return false;

			return true;
		}

		return false;
	}, [horaAtendimento]);

	useEffect(() => {
		let interval: NodeJS.Timer;

		if (!handleValidate()) {
			setShowTelemedicine(false);
			setCanCancel(false);
		} else {
			if (situation === "Agendado" || situation === "Confirmado" || situation === "Esperando" || situation === "Em atendimento") {
				handleVerifyTime();
				interval = setInterval(() => {
					if (!shouldCalculate.current) clearInterval(interval);
					else handleVerifyTime();
				}, 60000);
			}
		}
		return () => {
			clearInterval(interval);
		};
	}, [handleVerifyTime, handleValidate, situation]);

	return { showTelemedicine, canCancel };
};

export default useTimer;
